import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import Box from "./Box";


type Props = {
	sx?: React.CSSProperties;
} & React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>;

type SectionProps = {
	title?: string;
	children?: React.ReactNode;
};

type RowProps = {
	children: React.ReactNode;
	wrap?: boolean;
};

Form.Section = ({ title, children }: SectionProps) => (
	<Box.Column gap={2}>
		{title && <Typography variant="h6">{title}</Typography>}
		{children}
	</Box.Column>
);

Form.Row = ({ children, wrap = false }: RowProps) => (
	<Box gap={2} sx={{ maxWidth: "100%", flexWrap: wrap ? "wrap" : "nowrap" }}>
		{children}
	</Box>
);

export default function Form({ sx, onSubmit, ...props }: Props) {
	const theme = useTheme();
	const style = {
		root: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(2)
		}
	} as StyleProps;

	const submit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (onSubmit) onSubmit(e);
	};

	return <form {...props} onSubmit={submit} style={{ ...style.root, ...sx }} />;
}